import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {DragDropModule} from '@angular/cdk/drag-drop';

import {AcButtonModule} from '../ac-button/ac-button.module';
import {AcRadioButtonsGroupModule} from '../ac-radio-buttons-group/ac-radio-buttons-group.module';
import {AcCheckboxModule} from '../ac-checkbox/ac-checkbox.module';
import {AcDialogComponent} from './ac-dialog.component';

import {AcDialogHostComponent} from './ac-dialog-host/ac-dialog-host.component';
import {ConfirmDialogComponent} from './ac-dialogs/confirm-dialog/confirm-dialog.component';
import {FailDialogComponent} from './ac-dialogs/failed-dialog/failed-dialog.component';
import {InfoDialogComponent} from './ac-dialogs/info-dialog/info-dialog.component';
import {ErrorDialogComponent} from './ac-dialogs/error-dialog/error-dialog.component';
import {InfraPipesModule} from '../../pipes/infra.pipes.module';
import {AcIconsModule} from '../ac-icons/ac-icons.module';
import {AcDialogActionsDirective} from './directives/ac-dialog-actions.directive';
import {AcDialogTitleDirective} from './directives/ac-dialog-title.directive';
import {AcDialogCloseDirective} from './directives/ac-dialog-close.directive';
import {AcProgressModule} from '../ac-progress/ac-progress.module';
import {AcDialogAdditionalActionsDirective} from './directives/ac-dialog-additional-actions.directive';
import {InfraDirectivesModule} from '../../directives/infra.directives.module';
import {AcInputContainerModule} from "../ac-input-container/ac-input-container.module";
import {AcTextFieldModule} from "../ac-text-field/ac-text-field.module";
import {FormsModule} from "@angular/forms";
import {MatInput} from "@angular/material/input";

const acDialogs = [ConfirmDialogComponent, FailDialogComponent, InfoDialogComponent, ErrorDialogComponent];
const directives = [AcDialogActionsDirective, AcDialogTitleDirective, AcDialogCloseDirective, AcDialogAdditionalActionsDirective];

@NgModule({
    declarations: [
        AcDialogComponent,
        AcDialogHostComponent,
        ...directives,
        ...acDialogs
    ],
    imports: [
        CommonModule,
        DragDropModule,
        AcButtonModule,
        AcRadioButtonsGroupModule,
        AcCheckboxModule,
        AcIconsModule,
        AcProgressModule,
        InfraDirectivesModule,
        InfraPipesModule,
        AcInputContainerModule,
        AcTextFieldModule,
        FormsModule,
        MatInput,
    ],
    exports: [AcDialogComponent, AcDialogHostComponent, ...directives, ...acDialogs]
})
export class AcDialogModule {
}
